export default '5.24.2';
